import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmModalComponent } from './confirm-modal.component';

@NgModule({
  declarations: [ConfirmModalComponent],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
  ],
  exports: [ConfirmModalComponent],
})
export class ConfirmModalModule {}
